import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';

import { TranslationLoaderService } from '@common/translation-loader.service';

export const translationResolver: ResolveFn<void> = async (route, state) => {
    const translationLoaderService = inject(TranslationLoaderService);
    await translationLoaderService.loadTranslations(route.data);
};
